import type { FirstPaymentDefinitionsDTO } from '@/shared/model';

export enum PrepaymentDeadlineKind {
  BeforeCheckIn = 'beforeCheckIn',
  AfterReservation = 'afterReservation',
}

export interface PrepaymentDeadline {
  kind: PrepaymentDeadlineKind;
  days: number;
}

/** Вариант предоплаты туроператора: какую долю платим сразу и в какой срок вносим остаток. */
export interface PrepaymentOption {
  /** Доля первого платежа в процентах: поиск отдаёт её дробью от единицы, слайс переводит один раз. */
  percent: number;
  deadline: PrepaymentDeadline | null;
}

/** Блок шторки: логотип туроператора и все его варианты предоплаты. */
export interface PrepaymentOperator {
  id: number;
  name: string;
  logo: string;
  options: PrepaymentOption[];
}

/** Минимальный первый платёж карточки и доля той пары (продукт, определение), что его дала. */
export interface PrepaymentSummary {
  amount: number;
  /** Доля первого платежа в процентах — как и в `PrepaymentOption`, уже переведённая из дроби. */
  percent: number;
}

/**
 * Структурное подмножество `Product` — всё, что слайсу нужно знать о продукте.
 * Благодаря ему `entities/prepayment` не импортирует `entities/product`: кросс-импорты слайсов
 * одного слоя запрещены, а ради трёх полей заводить gateway незачем (тот же приём, что в
 * `getProductsConfirmationType`).
 */
export interface PrepaymentSource {
  price: number;
  operator: { id: number; nameRu: string; cover: string } | null;
  firstPaymentDefinitions: FirstPaymentDefinitionsDTO[];
}
